import React from 'react';
import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const CampusActionInsert = ({
    onToggleCreateCampusSitesModal,
    onToggleCreateSiteModal,
    onToggleDeleteCampusModal,
    onToggleEditCampusModal
}) => (
    <div className={classes.agentActions}>
        <ActionsPanelItem
            title="Edit Campus Information"
            iconUrl="/assets/images/campusTreeIcon.svg"
            onClick={() => onToggleEditCampusModal(true)}
        />
        <ActionsPanelItem
            title="Create a new Site"
            iconUrl="/assets/images/siteTreeIcon.svg"
            onClick={() => onToggleCreateSiteModal(true)}
        />
        <ActionsPanelItem
            title="Add Sites to Campus"
            iconUrl="/assets/images/siteTreeIcon.svg"
            onClick={() => onToggleCreateCampusSitesModal(true)}
        />
        <ActionsPanelItem
            title="Delete Campus"
            iconUrl="/assets/images/deleteIconColor.svg"
            onClick={() => onToggleDeleteCampusModal(true)}
        />
    </div>
);

CampusActionInsert.defaultProps = {
    onToggleDeleteCampusModal: () => {},
    onToggleEditCampusModal:   () => {}
};

CampusActionInsert.propTypes = {
    onToggleDeleteCampusModal: func,
    onToggleEditCampusModal:   func
};

export default CampusActionInsert;
